"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization converter of {@link PriceImpactProductReport}.
 *
 * @author Michal Sevcenko
 */


var PriceImpactProductReportConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceImpactProductReportConverter, _DataObjectConverter_);

  function PriceImpactProductReportConverter() {
    _classCallCheck(this, PriceImpactProductReportConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceImpactProductReportConverter).apply(this, arguments));
  }

  return PriceImpactProductReportConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceImpactProductReportConverter = PriceImpactProductReportConverter;